import AfterFetchComponent from '@/components/base/AfterFetchComponent'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import i18n from "@/lang/lang";
import {Loan, LoanConfig} from "@/store/modules/loanConfiguration";
import Component from 'vue-class-component'
import {Action, Getter, Mutation} from 'vuex-class'


@Component({})
export default class LoanConfigurationComponent extends AfterFetchComponent {

  @Action('updateLoanConfiguration', StoreNamespace.LOAN_CONFIG) updateLoanConfiguration: any
  @Action('getLoanConfigurationDetails', StoreNamespace.LOAN_CONFIG) getLoanConfigurationDetails: any

  @Getter('loanConfig', StoreNamespace.LOAN_CONFIG) loanConfig!: LoanConfig;
  @Getter('loan', StoreNamespace.LOAN_CONFIG) loan!: Loan;

  @Mutation('setLoan', StoreNamespace.LOAN_CONFIG) setLoan: any
  @Mutation('setLoanConfig', StoreNamespace.LOAN_CONFIG) setLoanConfig: any

  private loanConfigurationDetailsError: boolean = false;
  private updateLoanConfigurationError: boolean = false;
  private haveEducationFund: boolean = false;
  private maximumAmountError: boolean = false;
  private percentLiquidAmountError: boolean = false;
  private percentIlliquidAmountError: boolean = false;
  private submitError: boolean = false;

  private activeFundFields: any = [
    {key: 'id', label: " "},
    {key: 'fundName', label: i18n.t('loanConfiguration.optionName')},
    {key: 'fundNumber', label: i18n.t('loanConfiguration.fundNumber')},
  ];

  private yearOptionsFields: any = [
    {key: 'loanType', label: i18n.t('loanConfiguration.loanType')},
    {key: 'interest1YearsToExpiration', label: i18n.t('loanConfiguration.interest1YearsToExpiration')},
    {key: 'interest2YearsToExpiration', label: i18n.t('loanConfiguration.interest2YearsToExpiration')},
    {key: 'interest1YearsToExpiration', label: i18n.t('loanConfiguration.interest1YearsToExpiration')},
    {key: 'interest3YearsToExpiration', label: i18n.t('loanConfiguration.interest3YearsToExpiration')},
    {key: 'interest4YearsToExpiration', label: i18n.t('loanConfiguration.interest4YearsToExpiration')},
    {key: 'interest5YearsToExpiration', label: i18n.t('loanConfiguration.interest5YearsToExpiration')},
    {key: 'interest6YearsToExpiration', label: i18n.t('loanConfiguration.interest6YearsToExpiration')},
    {key: 'interest7YearsToExpiration', label: i18n.t('loanConfiguration.interest7YearsToExpiration')},
    {key: 'rating', label: i18n.t('loanConfiguration.rating')},
  ];

  mounted() {
    this.getLoanConfigurationDetails({requestorCallback: this})
  }

  onSuccess(data ?: any, requestName ?: string, message ?: string, success ?: boolean): void {
    switch (requestName) {
      case 'loanConfigurationDetails':
        this.setLoan(data.loan)
        this.setLoanConfig(data.loanConfig)
        this.haveEducationFund = data.haveEducationFund;
        break

      case 'loanConfiguration':
        this.showSuccessAction();
    }
  }

  onError(messages: string[], code: number, requestName?: string): void {
    switch (requestName) {
      case 'loanConfigurationDetails':
        this.loanConfigurationDetailsError = true;
        break;

      case 'loanConfiguration':
        this.updateLoanConfigurationError = true;
        break;

      default:
        this.handleOnError(messages, code, requestName)
    }
  }

  private loanAmountFormatter(fieldToChange: string) {
    if (fieldToChange === "") {
      return 0;
    }

    return fieldToChange
  }

  private onMaximumAmountChange(): void {
    if (this.loanConfig.maximumAmount < this.loanConfig.minimumAmount) {
      this.maximumAmountError = true;
    } else {
      this.maximumAmountError = false;
    }
  }

  private illiquidAndLiquidAmountFormatter(fieldToChange: string) {
    const number: number = Number(fieldToChange)
    if (Number.isNaN(number) || fieldToChange === "") {
      return '0'
    }

    return fieldToChange
  }

  private onIlliquidAmountChange() {
    if (this.loan.percentIlliquidAmount > 1 || this.loan.percentIlliquidAmount < 0) {
      this.percentIlliquidAmountError = true
    } else {
      this.percentIlliquidAmountError = false
    }
  }

  private onLiquidAmountChange() {
    if (this.loan.percentLiquidAmount > 1 || this.loan.percentLiquidAmount < 0) {
      this.percentLiquidAmountError = true
    } else {
      this.percentLiquidAmountError = false
    }
  }

  private onCheckboxInputActiveFundFlag(id: string) {
    let activeFundFlag = this.loan.activeFundFlags.filter(current => current.id === id)[0];
    activeFundFlag.checked = !activeFundFlag.checked;
  }

  private numberFormatter(value: string): string {
    const number: number = Number(value)
    if (Number.isNaN(number) && !(value.length === 1 && value === '-')) {
      return '0'
    }

    return value
  }

  private onSaveChangesClick(): void {
    this.submitError = false;

    if (this.loanConfigurationDetailsError ||
      this.updateLoanConfigurationError ||
      this.maximumAmountError ||
      this.percentLiquidAmountError ||
      this.percentIlliquidAmountError) {
      this.submitError = true;
      return;
    }

    this.updateLoanConfiguration({
      requestorCallback: this,
      requestBody: {
        loanConfig: this.loanConfig,
        loan: this.loan
      }
    })
  }

  private closePopupProblem(): void {
    this.loanConfigurationDetailsError = false;
    this.updateLoanConfigurationError = false;
  }

  private showSuccessAction() {
    this.$root.$emit('showAlertNotification', {
      toShow: true,
      message: 'loanConfiguration.updatedSuccessfully',
      icon: 'checkCircle',
      secondsToDisappear: 3
    })
  }
}
